import { create } from 'zustand';

import { productDetails } from '../data/product-details';

type Users = {
  min?: string;
  max: string;
};

type Benefits = {
  label: string;
  details: string[];
};

export type ProductDetailsType = {
  type: string;
  description: string;
  price: number;
  users: Users;
  body: string[];
  tier_id: string;
  product_id: string;
  benefits: Benefits[];
};

export type UseSubscriptionProductsStore = ProductDetailsType[];

const defaultValue: UseSubscriptionProductsStore[] = productDetails;

const useResourcesPaginationStore = create<UseSubscriptionProductsStore[]>(
  () => [...defaultValue],
);

export const useSubscriptionProducts = () =>
  useResourcesPaginationStore((state) => state);

export const setSubscriptionProducts = (data: UseSubscriptionProductsStore[]) =>
  useResourcesPaginationStore.setState([...data]);

export const resetResourcesStore = () =>
  useResourcesPaginationStore.setState({ ...defaultValue });
